import { createRoot } from "react-dom/client";
import App from "./app/App.jsx";
import ErrorBoundary from "./components/common/ErrorBoundary.jsx";
import { initGlobalErrorCapture } from "./utils/errorReporter.js";

initGlobalErrorCapture();

createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
